<template>
  <v-form ref="recommendationForm">
    <v-card
      class="flex-col-center-start pa-6 direction-ltr gap-3"
      height="100%"
    >
      <v-row dense class="w-100">
        <v-col v-for="type in targetItems" :key="type" cols="12" class="px-2">
          <v-card
            outlined
            min-height="80px"
            class="w-100 px-4 flex-row-start-center"
          >
            <div class="recommendation-label">
              {{ $t(type) }}
            </div>
            <v-text-field
              @input="(val) => onValueChange(type, val)"
              :value="values[type]"
              :rules="[
                rules.required,
                rules.range(
                  values[type],
                  RECOMMENDATION_RANGES[type].min,
                  RECOMMENDATION_RANGES[type].max
                ),
              ]"
              background-color="background"
              :suffix="`(${units[type]})`"
              type="number"
              flat
              solo
              dense
              class="recommendation-input pt-6 ml-auto"
            />
          </v-card>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <v-btn
        color="text"
        class="white--text"
        min-width="250"
        :loading="loading"
        @click="onSubmit"
      >
        {{ $t("calculate") }}
      </v-btn>
    </v-card>
  </v-form>
</template>

<script>
import {
  RECOMMENDATION_RANGES,
  RECOMMENDATION_UNIT,
  VALIDATION_RULES,
} from "@/core/constants";

export default {
  name: "RecommendationForm",

  props: {
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      targetItems: ["carbon", "metallization"],
      values: {
        carbon: null,
        metallization: null,
      },
      rules: VALIDATION_RULES,
      units: RECOMMENDATION_UNIT,
      RECOMMENDATION_RANGES,
    };
  },

  methods: {
    onSubmit() {
      const isValid = this.$refs.recommendationForm.validate();
      if (isValid) {
        const payload = {
          carbon: this.values.carbon,
          metal: this.values.metallization,
        };
        this.$emit("submit", payload);
        this.resetForm();
      }
    },
    onValueChange(type, val) {
      this.values[type] = Number(val);
      this.$emit("change", { ...this.values });
    },
    resetForm() {
      this.values = {
        carbon: null,
        metallization: null,
      };
      if (this.$refs.recommendationForm) {
        this.$refs.recommendationForm.resetValidation();
      }
    },
  },
};
</script>

<style lang="scss">
.recommendation-label {
  font-weight: 500;
  font-size: 16px;
}
.recommendation-input {
  max-width: 210px;
  direction: ltr;
}
</style>
